module.exports = __webpack_public_path__ + "img/logo_large.53331fdf.png";